export enum ResetType {
    ResetRequest = 'ResetRequest',
    DeviceLimit = 'DeviceLimit',
    Expiration = 'Expiration'
}